module.exports = __webpack_public_path__ + "static/media/pound-sign.aefbe639.svg";